'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = text;

var _actions = require('./actions');

var _util = require('@its/util');

function text() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { roles: [] };
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_USER_ROLES:
      return (0, _util.merge)(state, { roles: action.payload });
    default:
      return state;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/UserContainer/reducer.js
 ** module id = 481
 ** module chunks = 0
 **/